/**
 * Traeloo Premium Interaction Engine
 */

document.addEventListener('DOMContentLoaded', () => {
    initScrollProgress();
    initParallaxEffects();
    initEntranceAnimations();
    initShippingBar();
    initDarkMode();
    initPremiumHeader();
    initLookbook();
});

// 0. Función Blindada de Navegación Traeloo
function toggleTraelooMenu(drawerId) {
    const details = document.querySelector(`#Details-menu-drawer-container-${drawerId}`);
    if (!details) {
        console.error(`Traeloo: No se encontró el drawer ${drawerId}`);
        return;
    }
    
    const isOpen = details.hasAttribute('open');
    const header = document.querySelector('.section-header');
    
    if (!isOpen) {
        // Abrir Menú
        details.setAttribute('open', '');
        setTimeout(() => {
            details.classList.add('menu-opening');
        }, 10);
        document.body.classList.add('overflow-hidden-tablet');
        if(header) header.classList.add('menu-open');
    } else {
        // Cerrar Menú
        details.classList.remove('menu-opening');
        setTimeout(() => {
            details.removeAttribute('open');
        }, 400);
        document.body.classList.remove('overflow-hidden-tablet');
        if(header) header.classList.remove('menu-open');
    }
}

// 1. Barra de progreso de lectura
function initScrollProgress() {
    const progressBar = document.getElementById('scroll-progress');
    if (!progressBar) return;

    window.addEventListener('scroll', () => {
        const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPosition = window.scrollY;
        const progress = (scrollPosition / windowHeight) * 100;
        progressBar.style.width = `${progress}%`;
    });
}

// 2. Cursor personalizado eliminado a petición del usuario

// 3. Efectos Parallax en banners
function initParallaxEffects() {
    const banners = document.querySelectorAll('.banner__media img, .image-with-text__media img');

    window.addEventListener('scroll', () => {
        const scroll = window.scrollY;
        banners.forEach(img => {
            const speed = 0.15;
            const offset = scroll * speed;
            img.style.transform = `translateY(${offset}px) scale(1.1)`;
        });
    });
}

// 4. Animaciones de entrada escalonadas
function initEntranceAnimations() {
    const observerOptions = {
        threshold: 0.05,
        rootMargin: '50px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.section-scroll-reveal, .card-wrapper, .footer__content-top').forEach(el => {
        observer.observe(el);
    });
}

// 5. Barra de envío gratis dinámica
function initShippingBar() {
    const container = document.querySelector('.shipping-bar-container');
    if (!container) return;

    const threshold = parseInt(container.getAttribute('data-threshold')) || 0;
    const total = parseInt(container.getAttribute('data-total')) / 100; // Shopify total is in cents
    const messageEl = container.querySelector('.shipping-bar-message');
    const juice = container.querySelector('.shipping-bar-juice');

    if (threshold === 0 || total >= threshold) {
        messageEl.innerHTML = "✨ ¡Felicidades! Tienes <strong>Envío Gratis</strong> a todo Chile";
        if (juice) juice.style.width = '100%';
    } else {
        const remaining = Math.max(0, threshold - total);
        const percentage = Math.min(100, (total / threshold) * 100);
        messageEl.innerHTML = `Te faltan <strong>$${remaining.toLocaleString()}</strong> para el envío gratis`;
        if (juice) juice.style.width = `${percentage}%`;
    }
}

// Escuchar actualizaciones del carrito de Shopify (Dawn usa eventos de pubsub)
if (window.pubsub) {
    window.pubsub.subscribe('cart-updated', (data) => {
        // Intentar obtener el nuevo total del data si viene en el evento
        if (data && data.cart && data.cart.total_price) {
            const container = document.querySelector('.shipping-bar-container');
            if (container) container.setAttribute('data-total', data.cart.total_price);
        }
        setTimeout(initShippingBar, 500);
    });
}

// 6. Sistema de Modo Oscuro
function initDarkMode() {
    const toggleBtn = document.getElementById('dark-mode-toggle-btn');
    if (!toggleBtn) return;

    // Verificar preferencia guardada o del sistema
    const currentMode = localStorage.getItem('theme-mode');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (currentMode === 'dark' || (!currentMode && prefersDark)) {
        document.body.classList.add('dark-mode');
    }

    toggleBtn.addEventListener('click', () => {
        document.body.classList.toggle('dark-mode');
        const isDark = document.body.classList.contains('dark-mode');
        localStorage.setItem('theme-mode', isDark ? 'dark' : 'light');
    });
}

// 7. Lógica del Header Premium
function initPremiumHeader() {
    const menuBtn = document.getElementById('header-menu-premium-trigger');
    const standardDrawerTrigger = document.querySelector('.header__icon--menu summary');

    if (menuBtn && standardDrawerTrigger) {
        menuBtn.addEventListener('click', () => {
            standardDrawerTrigger.click();
        });
    }
}

// 8. Lookbook Mobile Support
function initLookbook() {
    const hotspots = document.querySelectorAll('.lookbook__hotspot');
    
    hotspots.forEach(hotspot => {
        hotspot.addEventListener('touchstart', (e) => {
            // Si el click es en el enlace de la tarjeta, dejamos que pase
            if (e.target.closest('.lookbook__card-title')) return;
            
            e.preventDefault();
            // Cerrar otras tarjetas
            hotspots.forEach(h => {
                if (h !== hotspot) h.classList.remove('is-active');
            });
            hotspot.classList.toggle('is-active');
        }, { passive: false });
    });

    // Cerrar al tocar fuera
    document.addEventListener('touchstart', (e) => {
        if (!e.target.closest('.lookbook__hotspot')) {
            hotspots.forEach(h => h.classList.remove('is-active'));
        }
    });
}
// Sync trigger Thu Apr  9 16:42:01 -04 2026
